import React, {useEffect} from 'react';
// import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from "react-intl";

import {setActiveTab} from "./VisualizerManagementActions";
import {hasSubscriptions} from "../../utilities/subscriptionFunctions";
import {AccessRights, PARTS} from "../../schemas/accessRightsModel";
import {AVAILABLE_VISUALIZERS} from "../../constants/dashboard";

const VisualizerManagementTabs = (props) => {

  const {availableTabs, activeTab, setActiveTab} = props;

  useEffect(() => {
    setActiveTab(availableTabs[0]);
  }, [])

  return (
    <ul className="tabs">
      {availableTabs.map((tab) => {
        return (
          <li className={"tab" + (activeTab === tab ? " tab--active" : "")}
              key={tab}
              onClick={() => setActiveTab(tab)}>
            {tab === "mobile_links" ? "Mobile Links" : <FormattedMessage id={"wizard.subscription." + tab}/>}
          </li>
        )
      })}
    </ul>
  )

}

const mapStateToProps = (store) => {
  const {allSubscriptions} = hasSubscriptions(store);
  const {activeTab} = store.visualizerManagement;
  const AR = AccessRights.get(store);
  return {
    activeTab,
    availableTabs: AR.v(PARTS.VIS_MNGM_NEW_LINKS) ? [...allSubscriptions, "mobile_links"] : allSubscriptions
  }
}

const mapDispatchToProps = {
  setActiveTab
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerManagementTabs);
